import React, { useEffect, useState } from "react";

import "./Laboratory.css";

import BtnAdd from "../Commons/Buttons/BtnAdd";
import AntDTable from "../AntDTable/AntDTable";
import SelectField from "../Commons/Forms/SelectField";
import DeleteModal from "../Modals/DeleteModal";

// import { Row, Col } from "react-bootstrap";
import { Card, Button as AntButton, Input } from "antd";
import { useParams } from "react-router-dom";
import {
  deleteLabResult,
  getLabTests,
} from "../Helpers/API/LabApi/LaboratoryApi";
import { getLaboratoryResult } from "../Helpers/API/LabApi/LaboratoryResultApi";
import { capitalizeFirstLetter, formatDate, formatLabel } from "../Helpers/Utilities/Common";
import { toast } from "react-toastify";
import { SeeAttachment } from "../Radiology/SeeAttachment";
import { RefreshRounded } from "@mui/icons-material";

function LaboratoryResults(props) {
  const { id } = useParams();
  const [searchLabTest, setSearchLabTest] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [laboratories, setLaboratories] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});

  // Function to delete lab result API
  const handleDelete = async () => {
    const res = await deleteLabResult(selectedRow.id);
    if (res.data) {
      toast.success(res.data.message);
      setSelectedRow({});
      setShowDelete(false);
      fetchData();
    } else if (res.error) {
      res.error.data.messages.error_messages.forEach((err) => {
        toast.error(err);
      });
    }
  };

  // Function show lab form
  function handleShowLabForm() {
    props.setShowCheckupTabs(false)
    props.showLabForm(true);
  }

  // Function get Lanoratory Result
  async function fetchData() {
    setShowLoader(true);
    const response = await getLaboratoryResult(id, null, null, searchLabTest);
    if (response.error) {
      setTableData([]);
    } else {
      var _parsed = response.data.data.map((lab) => {
        return {
          ...lab,
          formatted_lab_type_name:
            lab.lab_type_name !== "laboratory" && lab.lab_type_name !== "others"
              ? formatLabel(lab.lab_test_sub_type).toUpperCase()
              : formatLabel(lab.lab_type_name).toUpperCase(),
          attachment: <SeeAttachment attachments={lab.lab_result_attachments} />,
          formattedResultDate: formatDate(lab.result_date),
        };
      });
      setTableData(_parsed);
    }
    setShowLoader(false);
  }

  function handleLabTestChange(e) {
    setSearchLabTest(e); 
  }

  const handleEmptySearch = (e) => {
    if(e.target.value === ''){
      setSearchLabTest(""); 
    }
  };
  
  useEffect(() => {
      fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchLabTest]);

  return (
    <div>
      <Card className="card-with-table" style={{ minHeight: "500px" }}>
        <div>
          <div className="col pt-1 mb-4">
            <div className="row">
              <div className="col" style={{ display: 'flex'}}> 
                <h5 className="font-bold">LABORATORY RESULT</h5>
                <AntButton
                  type="text"
                  className="px-2"
                  onClick={fetchData}
                  icon={<RefreshRounded />}
                />
              </div>
              <div className="col-3">
                <BtnAdd
                  label={"+ Add Record"}
                  size={"md"}
                  onClick={(e) => handleShowLabForm()}
                />
              </div>
            </div>
          </div>
         <div className="row">
          <div className="col-4 pt-1 mb-2 d-flex justify-content-start">
              <Input.Search
                placeholder="Search Lab/Test"
                allowClear
                size="medium"
                onSearch={(e)=>handleLabTestChange(e)}
                onChange={(e)=>handleEmptySearch(e)}
              />
            </div>
         </div>
          <div className="lab-result-table">
            <AntDTable
              tableHeaders={["Date", "Lab", "Test", "Result", "Attachment"]}
              headerSelector={[
                "formattedResultDate",
                "formatted_lab_type_name",
                "lab_test_name",
                "result",
                "attachment",
              ]}
              tableData={tableData}
              loading={showLoader}
              scroll={{ x: true }}
              isClickable={false}
              searchExcluded={["formattedResultDate", "attachment"]}
            />
          </div>
        </div>
      </Card>
      {/* DELETE */}
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onDelete={handleDelete}
        title={`Are you sure you want to delete this result?`}
      />
    </div>
  );
}

export default LaboratoryResults;
